import { Box, FormControl, InputLabel, MenuItem, Paper, Select, Stack } from '@mui/material';
import { useState } from 'react';

import { CopyToClipboard } from '../../components/CopyToClipboard';
import { type TopicVeranstaltung } from '../../dtos';

type TopicVACardProps = {
  readonly topicVeranstaltungen: TopicVeranstaltung[];
};

export const TopicVACard = ({ topicVeranstaltungen }: TopicVACardProps) => {
  const [idx, setIdx] = useState(0);
  const json = JSON.stringify(topicVeranstaltungen[idx], null, 2);

  const handleSelectChange = (value: number) => {
    setIdx(value);
  };

  return (
    <Paper sx={{ width: '100%', maxWidth: '100vw', padding: 2 }}>
      <Stack direction="column" spacing={2}>
        <Box display="flex" alignItems="center" gap={2}>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-standard-label">SapId</InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={idx}
              // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion
              onChange={(event) => handleSelectChange(Number(event.target.value))}
              label="SAP-ID"
            >
              {topicVeranstaltungen.map((va, i) => (
                <MenuItem key={va.sapObjectId} value={i}>
                  {va.sapObjectId}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <CopyToClipboard value={json} />
        </Box>
        <pre>{json}</pre>
      </Stack>
    </Paper>
  );
};
